import { ExamPeriodMonitor, ExamPeriodMonitorState } from "@types"
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { setTimeWithSeconds } from "../../helpers";
import { setInterval, clearInterval } from 'worker-timers'

interface Props {
    examMonitor: ExamPeriodMonitor
}

export const TableTimeLeft = ({examMonitor}: Props) => {
    const [time, setTime] = useState<dayjs.Dayjs | undefined>(undefined);

    useEffect(() => {
        if (!time) {
            setTime(setTimeWithSeconds(examMonitor.instanceTimer))
        }    
    }, [time, examMonitor])

    useEffect(() => {
        const interval = setInterval(() => {
            if (examMonitor.state === ExamPeriodMonitorState.InProgress) {
                setTime(time => {
                    if (time?.isBefore(dayjs("00:00:01", "HH:mm:ss"))) {
                        clearInterval(interval);
                        return dayjs("00:00:00", "HH:mm:ss");
                    }
                    return time?.subtract(1, "second")
                });
            }
           
        }, 1000);

        return () => clearInterval(interval);
    }, [examMonitor])
    return (
        examMonitor.state === ExamPeriodMonitorState.InProgress || 
        examMonitor.state === ExamPeriodMonitorState.Paused ? 
        <span>{time?.format("HH:mm:ss")}</span> : <span>-</span>
    )
}